import { useState } from "react";
import { PaginationSrNo } from "../../constants/Helper/Helpers";
import { isEven } from "../../constants/Helper/NumbersFunction";
import { svgIcons } from "../../constants/utilities/ImagesExport/Icons";
import "./GarbageCollectionList.css";

const GarbageCollectionList = ({ data, page, HandleGarbageCollectionId }) => {
  const [selectedGarbage, setSelectedGarbage] = useState(null);

  return (
    <div className="GarbageCollectionList">
      <table className="table w-100 overflow-auto">
        <thead
          className="w-100  border-0"
          style={{ position: "sticky", top: "0", right: "0", zIndex: "1" }}
        >
          <tr className="bg_Table_Header">
            <th className="col_100px">Sr. No</th>
            <th className="col_200px">Ward/Area</th>
            <th className="col_200px">Owner Name</th>
            <th className="col_200px">House/Plot No.</th>
            <th className="col_200px">Date</th>
            <th className="col_250px">Garbage Type</th>
          </tr>
          <tr className="py-4">
            <th colSpan={5} className="py-3"></th>
            <th className="p-0 position-relative">
              <div className="d-flex garbage_type">
                <span
                  className="bg_Table_Header py-1 px-4 col_100px"
                  style={{ borderRadius: "5px 0px 0px 5px" }}
                >
                  Dry
                </span>
                <span
                  className="bg_Table_Header py-1 px-4 col_100px"
                  style={{ borderRadius: "0px 5px 5px 0px" }}
                >
                  Wet
                </span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {data?.map((item, i) => (
            <tr
              key={item._id || i}
              onClick={() => setSelectedGarbage(item)}
              style={{ cursor: "pointer" }}
            >
              <th scope="row" className={`${isEven(i + 1) && "Table_Data"}`}>
                {PaginationSrNo(page, i)}
              </th>
              <td
                className={`text-capitalize ${isEven(i + 1) && "Table_Data"}`}
              >
                {item?.wardId?.name?.toUpperCase() || "--"}
              </td>
              <td
                className={`text-capitalize ${isEven(i + 1) && "Table_Data"}`}
              >
                {item?.ownerName || "--"}
              </td>
              <td
                className={`text-capitalize ${isEven(i + 1) && "Table_Data"}`}
              >
                {item?.plotNo || "--"}
              </td>
              <td
                className={`text-capitalize ${isEven(i + 1) && "Table_Data"}`}
              >
                {item?.createdAt
                  ? new Date(item.createdAt).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : "--"}
              </td>
              <td
                className={`text-capitalize ${isEven(i + 1) && "Table_Data"}`}
              >
                <div className="d-flex">
                  <span className="px-1 col_100px">
                    {item?.dryWasteCollected} Kg
                  </span>
                  <span className="px-1 col_100px">
                    {item?.wetWasteCollected} Kg
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {(!data || data?.length === 0) && (
        <h6 className="DataNotFoundText">
          No garbage collection data found, Please select filter to see data...
        </h6>
      )}

      {selectedGarbage && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
          }}
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content border-0 rounded-4 shadow-lg animate__animated animate__fadeInDown">
              <div
                style={{
                  backgroundImage: "linear-gradient(135deg, #4f8c5d, #188a31)",
                  color: "#fff",
                }}
                className="modal-header text-white rounded-top-4 px-4 py-3"
              >
                <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                  🗑️ Garbage Collection Summary
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setSelectedGarbage(null)}
                ></button>
              </div>
              <div className="modal-body p-4 bg-light rounded-bottom-4">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="card shadow-sm p-3 border-0">
                      <h6 className="fw-bold text-muted mb-1">👤 Owner Name</h6>
                      <p className="mb-0 text-dark">
                        {selectedGarbage.ownerName || "--"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card shadow-sm p-3 border-0">
                      <h6 className="fw-bold text-muted mb-1">🏠 Plot No.</h6>
                      <p className="mb-0 text-dark">
                        {selectedGarbage.plotNo || "--"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card shadow-sm p-3 border-0">
                      <h6 className="fw-bold text-muted mb-1">
                        📍 Ward / Area
                      </h6>
                      <p className="mb-0 text-dark">
                        {selectedGarbage.wardId?.name?.toUpperCase() || "--"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card shadow-sm p-3 border-0">
                      <h6 className="fw-bold text-muted mb-1">
                        📅 Collection Date
                      </h6>
                      <p className="mb-0 text-dark">
                        {selectedGarbage.createdAt
                          ? new Date(
                              selectedGarbage.createdAt
                            ).toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            })
                          : "--"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card shadow-sm p-3 border-0">
                      <h6 className="fw-bold text-muted mb-1">🟢 Dry Waste</h6>
                      <span className="badge bg-success fs-6">
                        {selectedGarbage.dryWasteCollected} Kg
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card shadow-sm p-3 border-0">
                      <h6 className="fw-bold text-muted mb-1">🔵 Wet Waste</h6>
                      <span className="badge bg-primary fs-6">
                        {selectedGarbage.wetWasteCollected} Kg
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer bg-white border-0 rounded-bottom-4 px-4 py-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setSelectedGarbage(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GarbageCollectionList;
